/* Header utility cluster — the Updates and Account menus and the Cart link's live count badge
   (Option A · anchored panels, chosen 2026-09-06; the cart menu was dropped the same day because
   the cart page already does that job).
   Markup: snippets/header-top-v3.liquid · styles: assets/header-menus.css.
   One rule on every device: a menu opens on click or tap only, and closes on a second click of
   its button, a click outside, Esc, tabbing out, or opening the other menu. Nothing opens on hover
   (hover is what used to make the old cart panel vanish when the pointer left it).
   On phones (<= 768px) the panel is a fixed sheet under the pinned header over a dimmed page.
   The cart badge follows every add/change made on the page (the theme's ajax cart and any app
   that posts to /cart/add or /cart/change) and pops when the count goes up. */
(function () {
  'use strict';
  if (window.__dmHeaderMenus) { return; }
  window.__dmHeaderMenus = true;

  var open = null;   // { menu, btn, panel }
  var overlay = null;
  var phoneMq = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null;

  function isPhone() { return !!(phoneMq && phoneMq.matches); }
  function header() { return document.getElementById('header'); }

  function ensureOverlay() {
    if (overlay) { return overlay; }
    overlay = document.createElement('div');
    overlay.className = 'dm-overlay';
    overlay.hidden = true;
    overlay.addEventListener('click', function () { close(false); });
    document.body.appendChild(overlay);
    return overlay;
  }

  /* Anchor the panel 8px under the header row: on desktop relative to the icon cluster, on
     phones fixed under the pinned header (whatever the promo bar is doing at the time). */
  function place(panel) {
    var h = header();
    var hb = h ? h.getBoundingClientRect().bottom : 0;
    if (isPhone()) {
      var top = Math.max(0, Math.round(hb));
      panel.style.top = top + 'px';
      ensureOverlay().style.top = top + 'px';
    } else {
      var u = panel.closest('.dm-utility');
      var ut = u ? u.getBoundingClientRect().top : 0;
      panel.style.top = Math.round(hb - ut + 8) + 'px';
    }
  }

  function openMenu(menu) {
    var btn = menu.querySelector('.dm-hbtn');
    var panel = menu.querySelector('.dm-panel');
    if (!btn || !panel) { return; }
    close(false);
    place(panel);
    panel.hidden = false;
    panel.classList.add('is-open');
    btn.setAttribute('aria-expanded', 'true');
    menu.classList.add('is-open');
    if (isPhone()) {
      ensureOverlay().hidden = false;
      document.documentElement.classList.add('dm-menu-open');
    }
    open = { menu: menu, btn: btn, panel: panel };
    if (!panel.hasAttribute('tabindex')) { panel.setAttribute('tabindex', '-1'); }
    try { panel.focus({ preventScroll: true }); } catch (e) { panel.focus(); }
  }

  function close(returnFocus) {
    if (!open) { return; }
    var o = open;
    open = null;
    o.panel.hidden = true;
    o.panel.classList.remove('is-open');
    o.btn.setAttribute('aria-expanded', 'false');
    o.menu.classList.remove('is-open');
    if (overlay) { overlay.hidden = true; }
    document.documentElement.classList.remove('dm-menu-open');
    if (returnFocus) { try { o.btn.focus({ preventScroll: true }); } catch (e) { o.btn.focus(); } }
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) { return; }
    var btn = e.target.closest('.dm-menu > .dm-hbtn');
    if (btn) {
      e.preventDefault();
      var menu = btn.parentNode;
      // return focus to the button only for keyboard activation (detail 0): after a tap it would
      // leave a focus ring on the icon
      if (open && open.menu === menu) { close(e.detail === 0); } else { openMenu(menu); }
      return;
    }
    if (open && !open.panel.contains(e.target)) { close(false); }
  });

  document.addEventListener('keydown', function (e) {
    if (open && (e.key === 'Escape' || e.key === 'Esc')) { e.preventDefault(); close(true); }
  });

  document.addEventListener('focusin', function (e) {
    if (open && !open.panel.contains(e.target) && !open.btn.contains(e.target)) { close(false); }
  });

  var rafId = 0;
  function replace() {
    if (!open || rafId) { return; }
    rafId = window.requestAnimationFrame(function () { rafId = 0; if (open) { place(open.panel); } });
  }
  window.addEventListener('resize', replace);
  window.addEventListener('scroll', function () { if (open && isPhone()) { replace(); } }, { passive: true });
  if (phoneMq && phoneMq.addEventListener) { phoneMq.addEventListener('change', function () { close(false); }); }

  /* theme editor re-renders the header section */
  document.addEventListener('shopify:section:load', function () { close(false); });
  document.addEventListener('shopify:section:unload', function () { close(false); });

  /* ---- cart badge --------------------------------------------------------------------- */

  /* The count of main products, as snippets/dm-cart-count.liquid gives it when the page is built: add-on
     lines listed under their main product are part of that product. */
  function mainCount(cart) {
    var mains = {};
    cart.items.forEach(function (item) {
      var notes = item.properties || {};
      if (notes._add_on_link && !notes.For) { mains[notes._add_on_link] = true; }
    });
    return cart.items.reduce(function (count, item) {
      var notes = item.properties || {};
      if (notes.For && mains[notes._add_on_link]) { return count; }
      return count + item.quantity;
    }, 0);
  }

  var popTimer = 0;
  function setBadge(count) {
    var b = document.getElementById('dm-cart-badge');
    if (!b || typeof count !== 'number' || isNaN(count)) { return; }
    var prev = parseInt(b.textContent, 10);
    if (isNaN(prev)) { prev = 0; }
    b.textContent = String(count);
    b.hidden = count === 0;
    var link = document.getElementById('dm-cart-link');
    if (link) { link.setAttribute('aria-label', 'Cart, ' + count + (count === 1 ? ' item' : ' items')); }
    if (count > prev) {
      b.classList.remove('is-pop');
      void b.offsetWidth; // restart the animation
      b.classList.add('is-pop');
      if (link) {
        link.classList.add('is-added');
        clearTimeout(popTimer);
        popTimer = setTimeout(function () { link.classList.remove('is-added'); }, 1500);
      }
    }
  }

  var refreshing = null;
  function refreshCount() {
    if (refreshing) { return refreshing; }
    refreshing = fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (cart && cart.items) { setBadge(mainCount(cart)); } })
      .catch(function () {})
      .then(function () { refreshing = null; });
    return refreshing;
  }

  /* The theme's own ajax cart (ajaxify-shop.js) calls these with the new cart after Add to cart;
     they are defined at DOM ready, so wrap them once they exist. */
  function hookTheme() {
    if (!window.Shopify) { return; }
    ['onCartUpdate', 'updateQuickCart'].forEach(function (name) {
      var orig = Shopify[name];
      if (typeof orig !== 'function' || orig.__dmWrapped) { return; }
      var wrapped = function (cart) {
        var r = orig.apply(this, arguments);
        try { if (cart && cart.items) { setBadge(mainCount(cart)); } } catch (e) {}
        return r;
      };
      wrapped.__dmWrapped = true;
      Shopify[name] = wrapped;
    });
  }
  hookTheme();
  document.addEventListener('DOMContentLoaded', function () { setTimeout(hookTheme, 0); });
  window.addEventListener('load', function () { hookTheme(); setTimeout(hookTheme, 1500); });

  /* Anything else that changes the cart (apps, quick views) goes through /cart/add, /cart/change,
     /cart/update or /cart/clear: watch those requests and re-read the count afterwards. */
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  function watched(url) { return typeof url === 'string' && CART_RE.test(url); }
  try {
    if (window.fetch) {
      var origFetch = window.fetch;
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : (input && input.url);
        var p = origFetch.apply(this, arguments);
        if (watched(url)) { p.then(function () { setTimeout(refreshCount, 50); }, function () {}); }
        return p;
      };
    }
    if (window.XMLHttpRequest) {
      var origOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url) {
        if (watched(url)) { this.addEventListener('loadend', function () { setTimeout(refreshCount, 50); }); }
        return origOpen.apply(this, arguments);
      };
    }
  } catch (e) {}

  /* back/forward cache: the page comes back with the old count */
  window.addEventListener('pageshow', function (e) { if (e.persisted) { refreshCount(); } });
})();
